import CardBroadbandLabel from "components/Browse/CardBroadbandLabel";

const PhoneSection: React.FC<{
  product: any;
  index: number;
  labelImageUrl: string;
  label: string;
  postCustomerSummaryRequest: Function;
}> = ({ product, index, labelImageUrl, label, postCustomerSummaryRequest }) => {
  const browseProductsOrDisplayMessage = () => {
    let needToCallIn = product.hasService && (product.productId === 0 || !product.canUpgrade);

    return (
      <div className='select-phone-products'>
        {needToCallIn ? (
          <>
            <div className='browse-products-message'>
              <strong>Change Telephone Plan.</strong>
            </div>
            <div className='gap-2 btn-container'>
              <div style={{ fontSize: "14px", width: "200px" }}>
                Call <a href='tel:1-888-403-2667'>1-888-403-2667</a> to verify available upgrades.
              </div>
              <a className='btn btn-primary browse-products-button' type='button' href='tel:1-888-403-2667'>
                <strong>Call Now</strong>
              </a>
            </div>
          </>
        ) : (
          <>
            <div className='browse-products-message'>
              <strong>Select "Browse Products" below to choose from available services in your area.</strong>
            </div>
            <div className='gap-2 btn-container'>
              <button
                className='btn btn-primary browse-products-button'
                type='button'
                onClick={() => postCustomerSummaryRequest("TEL", null)}>
                <strong>Browse Products</strong>
              </button>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <div key={`int-${index}`} className='customer-summary-phone-section row mb-5'>
        <div className='core-type-container mb-5 mt-5'>
          <img className='core-type-image' src={labelImageUrl} alt='Comporium' />
          <h2 className='core-type-label'>{label}</h2>
        </div>
        {product?.cardName ? (
          <div className='core-type-product-card'>
            <div key={`item.cardName-${index}`} className='product-card-container me-2'>
              <div className='current-product-card me-2'>
                <div className='d-flex justify-content-center w-100'>
                  <div className='flair-flag'></div>
                </div>
                <div className='product-details'>
                  <h5>{product.cardName}</h5>
                  {product?.termPrice ? <p>{product.termPrice}</p> : null}
                </div>
                <div
                  className='current-product-footer'
                  onClick={() => (product.currentPlanHelpCenterLink ? window.open(product.currentPlanHelpCenterLink, "_blank") : false)}
                  style={product.currentPlanHelpCenterLink ? { cursor: "pointer" } : {}}>
                  CURRENT PLAN
                </div>
              </div>
              {product?.currentProductLabel ? <CardBroadbandLabel broadbandLabel={product.currentProductLabel} /> : null}
            </div>
            {product?.upgrades?.map((item: any, index: number) => {
              return (
                <div key={`item.cardName-${index}`} className='product-card me-2 mb-2'>
                  <div className='product-details'>
                    <h6 className='product-description'>{item.cardName}</h6>
                    <p>{item.price}</p>
                  </div>
                  <div className='product-footer' onClick={() => postCustomerSummaryRequest("TEL", item)}>
                    UPGRADE NOW
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <>{browseProductsOrDisplayMessage()}</>
        )}
      </div>
    </>
  );
};

export default PhoneSection;
